import { NovaDate, type DateLike, type Maybe, type Nullable } from '@nova/core';

export function parseApiDateTime(apiDateTime: Maybe<DateLike>): Nullable<Date> {
  if (apiDateTime == null) {
    return null;
  }

  const novaDate = new NovaDate(apiDateTime);
  if (novaDate.isValid()) {
    return novaDate.toJSDate();
  }

  return null;
}
